// @ts-ignore
import content from './md/reporting-that-reveals-revenue-leaks.md';

export const meta = {
  slug: 'reporting-that-reveals-revenue-leaks',
  title: 'Reporting That Reveals Revenue Leaks: 5 Metrics Every Home Service Business Should Track',
  excerpt: 'You can\'t fix what you can\'t see. Learn the five key metrics that reveal where money is slipping through the cracks in your business.',
  date: 'January 2025',
  readTime: '11 min read',
  image: '/docs/reporting-that-reveals-revenue-leaks/header.png'
};

export { content };
